import { Directive, ElementRef, OnInit, OnDestroy, inject } from '@angular/core';
import { WtFocusService } from '../services/wt-focus.service';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[wtFocusable]',
})
export class WtFocusableDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);
  private focusService = inject(WtFocusService);
  private control = inject(NgControl);

  ngOnInit(): void {
    if (!this.control.control) {
      return;
    }

    this.focusService.registerFocusableFormControl(this.control.control, this.el);
  }

  ngOnDestroy(): void {
    if (!this.control.control) {
      return;
    }
    this.focusService.deregisterFocusableFormControl(this.control.control);
  }
}
